/**
 * Ad hook event logging (Sprint 1: infra only, hooks land in Sprint 2)
 * Tracks per-hook funnel: shown -> accepted.
 */
import type { AdHookStat } from './exchangeState.js';

export type AdHookEvent = 'shown' | 'accepted';

/**
 * Pure helper: returns a new stats record with the event counted.
 */
export function recordAdHook(
  stats: Record<string, AdHookStat>,
  hookId: string,
  event: AdHookEvent
): Record<string, AdHookStat> {
  const prev = stats[hookId] ?? { shown: 0, accepted: 0 };
  return {
    ...stats,
    [hookId]: {
      shown: event === 'shown' ? prev.shown + 1 : prev.shown,
      accepted: event === 'accepted' ? prev.accepted + 1 : prev.accepted,
    },
  };
}
